/**
 * @license
 *-------------------------------------------------------------------------------------------
 * Copyright © 2025 Progress Software Corporation. All rights reserved.
 * Licensed under commercial license. See LICENSE.md in the package root for more information
 *-------------------------------------------------------------------------------------------
 */
import * as l from "react";
import { Button as m } from "@progress/kendo-react-buttons";
import { useLocalization as a } from "@progress/kendo-react-intl";
import { onDownPreventDefault as p } from "./utils.mjs";
import { messages as f } from "../messages/index.mjs";
import { selectAll as u } from "@progress/kendo-editor-common";
import { EditorToolsSettings as g } from "../config/toolsSettings.mjs";
const { selectAll: d } = g, C = (i) => {
  const { view: t, render: o, settings: e = d, ...n } = i, s = e.messages.title, c = l.useCallback(() => {
    t && (u(t.state, t.dispatch), t.focus());
  }, [t]), r = /* @__PURE__ */ l.createElement(
    m,
    {
      onClick: c,
      title: a().toLanguageString(s, f[s]),
      ...p,
      ...e.props,
      ...n
    }
  );
  return o ? o.call(void 0, r, { view: t }) : r;
};
export {
  C as SelectAll
};
